import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  "data-testid": "permissions-tree-skeleton",
  class: "flex flex-col gap-3 w-full animate-pulse"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h-5 w-14 bg-slate-200 rounded" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "h-4 flex-1 max-w-[280px] bg-slate-200 rounded" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "h-4 w-16 bg-slate-200 rounded ml-auto" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]


export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionsTreeSkeleton',
  props: {
    rows: { default: 5 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (n) => {
      return (_openBlock(), _createElementBlock("div", {
        key: n,
        class: _normalizeClass(["flex items-center gap-3 w-full", { 'ml-8': n % 2 === 0 }])
      }, _hoisted_5, 2))
    }), 128))
  ]))
}
}

})